import React from 'react';
import {Calendar} from "antd";
import moment from 'moment';
import Constants from "../../../services/Constants";

import './AvailabilityCalendar.css';
import {injectIntl} from "react-intl";

class AvailabilityCalendar extends React.Component {

  interventionMobility = () => {
    const {intervention: {journey: {properties = {}} = {}}} = this.props;
    const {mobility} = properties.mobility;
    return mobility;
  };

  isMotorbikeAvailable = (availableMobility, requestedMobility) => {
    const availableMotos = availableMobility.filter(m => Constants.MOBILITY_MOTOS.indexOf(m) >= 0);
    return (Constants.MOBILITY_MOTOS.indexOf(requestedMobility.name) >= 0 && availableMotos.length > 0);
  };

  isCarAvailable = (availableMobility, requestedMobility) => {
    const availableCars = availableMobility.filter(m => Constants.MOBILITY_CATEGORIES.indexOf(m) >= 0);
    return Constants.MOBILITY_CATEGORIES.indexOf(requestedMobility.name) >= 0 && availableCars.length > 0;
  };

  isVehicle = (requestedMobility) => {
    return (Constants.MOBILITY_VEHICLES.indexOf(requestedMobility.name) >= 0);
  };

  computeCellColor = (availability) => {
    const interventionMobility = this.interventionMobility();
    if (!availability) {
      return "calendar-box--closed";
    }
    if (this.isVehicle(interventionMobility) && !this.isCarAvailable(availability.mobility, interventionMobility) && !this.isMotorbikeAvailable(availability.mobility, interventionMobility)) {
      return "calendar-box--no-rental";
    }
    if (availability.status === Constants.DAY_OPEN.value) {
      return "calendar-box--available";
    }
    if (availability.status === Constants.DAY_OVERBOOKED.value) {
      return "calendar-box--available";
    }
    return "calendar-box--closed";
  };

  dateFullCellRender = (date) => {
    const {availabilities = []} = this.props;
    const formattedDate = moment(date).format(Constants.DATE_FORMAT_API);

    const selectedAvailability = availabilities.filter(a => a.day === formattedDate);
    const availability = selectedAvailability[0];
    const cellColor = this.computeCellColor(availability);

    return (
      <div className="ant-fullcalendar-date">
        <div className={cellColor + " calendar--rounded-value ant-fullcalendar-value"}>
          <div style={{position: 'relative', top: '30%'}}>
            {moment(date).format("D")}
          </div>
        </div>
      </div>
    );
  };

  render() {
    const {intl:{formatMessage}} = this.props;

    return (
      <div>
        <Calendar className="calendar--hidden-year"
                  fullscreen={false}
                  dateFullCellRender={this.dateFullCellRender}
                  disabledDate={() => true}
        />
        <div className="row">
          <div className="col-md-6 col-xxl-6" style={{textAlign: "center"}}>
            <span className="fc-event-dot calendar-legend__color--green"/> {formatMessage({id: 'appointment.planning.available'})}
          </div>
          <div className="col-md-6 col-xxl-6" style={{textAlign: "center"}}>
            <span className="fc-event-dot calendar-legend__color--orange"/> {formatMessage({id: 'appointment.planning.no-rental-car'})}
          </div>
        </div>
      </div>
    )
  }
}

export default injectIntl(AvailabilityCalendar);



// WEBPACK FOOTER //
// ./src/components/interventiondetail/planning/AvailabilityCalendar.js